document.addEventListener("DOMContentLoaded", function () {
  // Find all accordion containers
  const containers = document.querySelectorAll('[class^="mainSection_accordionContainer_"]');

  containers.forEach(function (container) {
    // Look for an active arrow inside this container
    const activeArrow = container.querySelector('[class*="Accordion_arrow_active"]');

    if (activeArrow) {
      // Find any panels inside the same container that start with Accordion_panel
      const panels = container.querySelectorAll('[class^="Accordion_panel"]');

      panels.forEach(function (panel) {
        panel.style.maxHeight = "none";
      });
    }
  });
});
